function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(255,255,255)",
      fillOpacity: 1
    },
    d: "M 1.585938 9.210938 L 0.738281 8.375 L 4.699219 4.4375 L 6.789062 6.523438 L 9.273438 4.023438 L 7.789062 4.023438 L 7.789062 2.851562 L 11.261719 2.851562 L 11.261719 6.3125 L 10.101562 6.3125 L 10.101562 4.875 L 6.773438 8.199219 L 4.6875 6.113281 Z M 1.585938 9.210938 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending_up.d1dcecd0d869cbe15a258be4edb16f3b.svg";
export { ForwardRef as ReactComponent };